import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import "./Scan.css";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useAuth from "../../hooks/useAuth";
import useLogout from "../../hooks/useLogout";

import TopBar from "./TopBar";
import { formatDate } from "../../utils/Utilities.js";

const InScan = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const logout = useLogout();
  const axiosPrivate = useAxiosPrivate();

  const [awbNumber, setAwbNumber] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [todayInScan, setTodayInScan] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const POST_IN_SCAN_URL = "/api/in-scan";
  const LIST_IN_SCAN_URL = "api/list-inscan";

  const handleRedirect = () => {
    navigate("/outscan");
  };
  const handleRedirect2 = () => {
    navigate("/listInScanByDate");
  };

  const signOut = async () => {
    await logout();
    navigate("/login");
  };

  const fetchListInScan = async () => {
    setLoading(true);
    try {
      const today = new Date();
      const fromDateFormatted = formatDate(today);
      const toDateFormatted = formatDate(today);

      const data = {
        franchise_id: auth.franchise_id,
        from_date: fromDateFormatted,
        to_date: toDateFormatted,
      };

      const response = await axiosPrivate.get(LIST_IN_SCAN_URL, {
        params: data,
      });

      setTodayInScan(response.data);
      setError(null);
    } catch (error) {
      console.error("Error fetching Bookings Consignments:", error);
      setError("Failed to load Booking Consignments");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchListInScan();
  }, []);

  const postInScan = async () => {
    try {
      const data = {
        awb_number: awbNumber,
        franchise_id: auth.franchise_id,
      };

      const response = await axiosPrivate.post(POST_IN_SCAN_URL, data);
      setResponseMessage(response.data);
    } catch (error) {
      console.error("Error:", error?.response?.data?.message || error.message);
      setResponseMessage(
        error.response?.data?.message || "An unexpected error occurred."
      );
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await postInScan();
    await fetchListInScan();
  };

  return (
    <>
      <section className="inscanbody">
        <br />
        <div className="wrapper4">
          <div className="d-flex align-items-center">
            {/* Left side */}
            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary newviewbtn"
            >
              ← Back
            </button>

            {/* Right side */}
            <div className="d-flex gap-2 ms-auto">
              <button
                onClick={handleRedirect2}
                type="button"
                className="btn btn-success top-bt"
              >
                InScan List
              </button>

              <button
                onClick={handleRedirect}
                type="button"
                className="btn btn-success top-bt"
              >
                Out Scan
              </button>
            </div>
          </div>

          {/* <button
            onClick={handleRedirect}
            type="button"
            className="btn btn-success ms-auto d-block top-bt"
          >
            Out Scan
          </button> */}

          <form onSubmit={handleSubmit}>
            <h3>In Scan</h3>
            <Row>
              <Col></Col>
              <Col>
                <center>
                  <div className="input-boxs">
                    <label htmlFor="awb_number">AWB Number</label>
                    <input
                      type="text"
                      id="awb_number"
                      placeholder=" "
                      value={awbNumber}
                      onChange={(e) => setAwbNumber(e.target.value)}
                      required
                    />
                  </div>
                </center>
                <center>
                  <button type="submit" className="btn scanbutton">
                    Submit
                  </button>
                </center>
              </Col>
              <Col></Col>
            </Row>
          </form>

          {responseMessage && (
            <div className="response-message">
              <p>{responseMessage.message || responseMessage}</p>
            </div>
          )}

          <div>
            {loading && <p>Loading...</p>}
            {error && <p>{error}</p>}

            {!loading && !error && todayInScan.length > 0 && (
              <table>
                <thead>
                  <tr>
                    <th>AWB Number</th>
                    <th>Consignment Type</th>
                    <th>Goods Name</th>
                    <th>Quantity</th>
                    <th>Weight</th>
                    <th>Inscan Time</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {todayInScan.map((booking, index) => (
                    <tr key={index}>
                      <td>{booking.awb_number}</td>
                      <td>{booking.consignment_type}</td>
                      <td>{booking.goods_name}</td>
                      <td>{booking.quantity}</td>
                      <td>{booking.weight}</td>
                      <td>{booking.scan_time}</td>
                      <td>{booking.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {!loading && !error && todayInScan.length === 0 && (
              <p>No bookings found</p>
            )}
          </div>
        </div>
      </section>

      <TopBar />
    </>
  );
};

export default InScan;
